import './App.css';
import React, { useCallback, useEffect, useState } from 'react';

import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './provider/AuthProvider';
import { isMobile } from 'react-device-detect';
import { LoaderProvider, Loader } from './provider/LoaderProvider';
import { Provider } from 'react-redux';
import { persistor, store } from './store';
import '@splidejs/react-splide/css';
import { ThemeProvider } from './provider/ThemeProvider';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from 'src/components/ui/sonner';
import useBroadcast from 'src/hooks/useBroadcast';
import { PATH_AUTH_SPA } from 'src/constants/spa-routes';
import { BROADCAST_CHANNELS, BROADCAST_MESSAGES } from 'src/constants/broadcast';
import { getEnvironment } from 'src/env/env';
import { useUtmAttributes } from 'src/hooks/useUtmAttributes';
import { router } from 'src/router';
import { clearOnLogout } from 'src/utils/clear.util';
import { PHProvider } from 'src/provider/PHProvider';
import { windowReloadHandler } from 'src/utils/window.utils';
import { KnowledgeBaseProvider } from 'src/provider/KnowledgeBaseProvider';

const App = () => {
  const [env, setEnv] = useState<Record<string, string> | null>(null);
  useUtmAttributes();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isSkip = params.get('skip') === 'true';

    sessionStorage.removeItem('environment');
    isSkip && sessionStorage.setItem('skip_onboarding', 'true');

    (async () => {
      const env = await getEnvironment();

      setEnv(env);
    })();
  }, []);

  const logoutHandler = () => {
    clearOnLogout();
    sessionStorage.removeItem('skip_onboarding');
    window.location.assign(PATH_AUTH_SPA.ROOT);
  };

  const onBroadcastAuth = useCallback((event: MessageEvent) => {
    if (event.data === BROADCAST_MESSAGES.LOGOUT) {
      logoutHandler();
    }
    if (event.data === BROADCAST_MESSAGES.WINDOW_RELOAD) {
      windowReloadHandler();
    }
  }, []);

  useBroadcast({
    channelName: BROADCAST_CHANNELS.AUTH,
    onMessage: onBroadcastAuth,
  });

  return env ? (
    <PHProvider isProduction={env.ENVIRONMENT === 'PROD'}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider>
            <AuthProvider>
              <KnowledgeBaseProvider>
                <div className={isMobile ? 'App_Container mobile' : 'App_Container desktop'}>
                  <LoaderProvider>
                    <Loader />
                    <RouterProvider router={router} />
                  </LoaderProvider>
                </div>
                <div id="popup-root"></div>
                <Toaster />
              </KnowledgeBaseProvider>
            </AuthProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </PHProvider>
  ) : null;
};

export default App;
